import React from "react";
import { Play } from "lucide-react";
import { SmartImg, SmartVideo } from "./SmartMedia";

// WhatsApp-style album grid for 2..N mixed image/video items.
export const AlbumGrid = ({ items, onOpen, local }) => {
  const n = items.length;
  const shown = items.slice(0, 4);
  const extra = n - 4;
  return (
    <div className="grid grid-cols-2 gap-0.5" style={{ width: 300 }} data-testid="chat-album-grid">
      {shown.map((it, i) => {
        const isVideo = it.type === "video";
        const wide = n === 3 && i === 0;
        return (
          <button
            key={i}
            onClick={(e) => { e.stopPropagation(); onOpen(i); }}
            className={`relative overflow-hidden bg-black/10 ${wide ? "col-span-2 aspect-[2/1]" : "aspect-square"}`}
            data-testid={`chat-album-item-${i}`}
          >
            {isVideo
              ? <SmartVideo remoteUrl={it.url} localUrl={local?.[i]?.url} className="h-full w-full object-cover" />
              : <SmartImg remoteUrl={it.url} localUrl={local?.[i]?.url} className="h-full w-full object-cover" />}
            {isVideo && (
              <span className="absolute inset-0 grid place-items-center pointer-events-none">
                <span className="h-9 w-9 rounded-full bg-black/55 grid place-items-center"><Play size={18} className="text-white ml-0.5" /></span>
              </span>
            )}
            {i === 3 && extra > 0 && (
              <div className="absolute inset-0 bg-black/55 grid place-items-center">
                <span className="text-white text-2xl font-bold">+{extra}</span>
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
};
